import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { AffiliateForm } from '@/features/users/affiliate/AffiliateForm';
import { Translation } from '@/hoslog-intl';
import { EditIcon } from '@/icons';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/affiliates/$affiliateId')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="affiliate.page.affiliateInfoForm.title" icon={EditIcon} />,
      title: <Translation id="affiliate.page.affiliateInfoForm.title" />,
    };
  },
});

function RouteComponent() {
  return (
    <div className="bg-card  p-8 rounded-lg !w-full">
      <AffiliateForm />
    </div>
  );
}
